'use strict'

function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32
}

module.exports = markdownSpace
